import {InputRightElement} from '@chakra-ui/react';

export default function ChakraInputRightElement({...rest}) {
    return <InputRightElement {...rest} />;
}
